// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"bfd52902","693":"9b2a4f66"}[chunkId] + ".chunk.js";
};